module.exports = __webpack_public_path__ + "img/10.f2aacb5.jpg";